import type { IMediaItem } from 'types/media'

/** Squared distance above this (10px radius) turns pointer-up into a non-click for selection. */
export const CLICK_MOVE_THRESHOLD_SQ = 10 * 10

/**
 * Maps each frame root element to its canvas item id (one DOM node per item).
 */
export const buildFrameElementToIdMap = (
  framesById: Map<string, HTMLDivElement>
): Map<Element, string> => {
  const elementToId = new Map<Element, string>()
  for (const [id, el] of framesById) {
    elementToId.set(el, id)
  }
  return elementToId
}

/**
 * `elementsFromPoint` returns topmost elements first. Returns the first id whose
 * frame element appears in that stack.
 */
export const findTopmostCanvasItemIdAtPoint = (
  clientX: number,
  clientY: number,
  frameElementToId: Map<Element, string>
): string | null => {
  for (const el of document.elementsFromPoint(clientX, clientY)) {
    const id = frameElementToId.get(el)
    if (id !== undefined) {
      return id
    }
  }
  return null
}

export const frameDisplayAreaSq = (it: IMediaItem): number =>
  it.width * it.height
